import DetailView from "../shared/DetailView";
export default function ProfileContactInfo({ contact, phone }) { return <DetailView title="Contact information" fields={[{ label: "Email", value: contact || "Not provided" }, { label: "Phone", value: phone || "Not provided" }]} />; }
